window.formStyles = window.formStyles || new Map();

window.formStyles.set("fix-close-btn-color", `
  ._formCloseButton_1684x_4:not(._withBackground_1684x_15) svg { 
    fill: #ffffff !important; 
  }
`);

window.formStyles.set("forms-bg-fix", `
  ._overlayBackground_1q1d2_123 {
    background-color: rgba(0, 0, 0, 0.4) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  section[data-sizing="form-wrapper"] {
    justify-items: end;
    display: grid !important;
    grid-template-columns: minmax(var(--min-form-width), var(--container-max-w)) !important;
    --container-max-w: 650px !important;
    --forms-padding-top: 85px !important;
    --forms-padding-bottom: 85px !important;
    --form-container-background-size: contain;
    --container-text-alignment: left;
    ._imageLoaded_1q1d2_237  { width: 100% !important;grid-column: 1;display: grid;border-radius: var(--container-border-radius); }
    ._gridItemContent_1q1d2_257  { width: 260px;grid-column: 1;z-index: 1; }
    ._formContainerCloseButtonPosition_1q1d2_282 { top: 30px; }
    ._formHeader_jnbzb_24 { margin: 5px auto 10px; }
    ._formHeader_jnbzb_24 ._textBody_2aowh_10 strong { font-weight: 400; }
    ._formDisclaimer_jnbzb_38 { display: none; }
    h2._textHeading_2aowh_35 { font-size: 24px; }
    h2._textHeading_2aowh_35::before {
      content: "Welcome to Droneer Shop";
      display: block;
      margin-bottom: 6px;
      font-size: 12px;
      line-height: 1.2;
      font-weight: 400;
      color: currentColor;
    }
    input._formInputField_nag3b_7 { border-radius: 40px; }
    button._formSubmitButton_jnbzb_106 { border-radius: 40px; }
    ._formContainer_1q1d2_30 { width: 800px; }
    ._formBannerContainer_z5ku3_1 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    ._formBannerHeading_z5ku3_9 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      order: 1;
    }
    ._formBannerHeading_z5ku3_9::before {
      content: "";
      width: 32px;
      height: 32px;
      flex: 0 0 32px;
      background: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='16' cy='16' r='14.5' stroke='%2337EF80' stroke-width='2'/%3E%3Cpath d='M10 16.4L14 20.3L22 12.4' stroke='%2337EF80' stroke-width='2.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
    }
    ._formBannerContainer_z5ku3_1 > ._textBody_2aowh_10 {
      order: 2;
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 14px;
      line-height: 1.4;
      color: rgba(255, 255, 255, 0.82);
    }
    ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2 {
      order: 3;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      width: fit-content;
      min-width: 214px;
      padding: 0 18px;
      margin-top: 14px;
      min-height: 38px;
      border: 1px solid rgba(255, 255, 255, 0.72);
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.02);
      color: #fff;
      overflow: hidden;
    }
    ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2 ._textBody_2aowh_10 {
      order: 1;
      padding: 0;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
    }
    ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2::after {
      content: "COPY";
      order: 3;
      font-size: 16px;
      line-height: 41px;
      color: #fff;
      font-family: Arial, sans-serif;
    }
    ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2.forms-copy-copied::after {
      content: "COPIED";
    }
    ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2 ._copyIcon_bboux_35 {
      order: 2;
      width: 1px;
      height: 20px;
      margin-right: 0;
      margin-left: 0;
      color: rgba(255, 255, 255, 0.7);
      background: rgba(255, 255, 255, 0.7);
    }
    ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2 ._copyIcon_bboux_35 svg {
      display: none;
    }
    ._imageLoaded_1q1d2_237::before { 
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      background-image: var(--form-container-background-image);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  @media (max-width: 768px) {
    section[data-sizing="form-wrapper"] {
      width: 328px;
      height: 530px;
      justify-items: center;
      --forms-padding-bottom: 215px !important;
      --forms-padding-top: 20px !important;
      --container-text-alignment: center;
      --form-container-background-size: cover;
      ._gridItemContent_1q1d2_257 {
        margin-top: -50px;
      }
      ._formBannerHeading_z5ku3_9 {
        align-items: center;
        width: 100%;
      }
      ._formBannerContainer_z5ku3_1 > button._copyToClipboardButton_bboux_2 {
        margin: 14px auto 0;
      }
      
      --form-container-background-image: url("//shop.droneer.com/cdn/shop/files/forms_background_mobile.jpg?v=1787706922&width=1600") !important;
      
    }
  }

  button[data-testid="form-teaser"] {
    border-radius: 40px !important;
  }
`);

function bindFormsCopyButtonState(root) {
  if (!root) {
    return;
  }

  root.querySelectorAll('button[class*="_copyToClipboardButton_"]').forEach((button) => {
    if (button.dataset.copyStateBound === "true") {
      return;
    }

    button.dataset.copyStateBound = "true";
    button.addEventListener("click", () => {
      button.classList.add("forms-copy-copied");

      clearTimeout(button.copyStateTimer);
      button.copyStateTimer = setTimeout(() => {
        button.classList.remove("forms-copy-copied");
      }, 3000);
    });
  });
}

const observedFormsCopyRoots = new WeakSet();

function observeFormsCopyRoot(root) {
  if (!root || observedFormsCopyRoots.has(root)) {
    return;
  }

  observedFormsCopyRoots.add(root);

  const observer = new MutationObserver(() => {
    bindFormsCopyButtonState(root);
  });

  observer.observe(root, {
    childList: true,
    subtree: true
  });
}

function bindFormsCopyButtons() {
  bindFormsCopyButtonState(document);
  observeFormsCopyRoot(document);

  document.querySelectorAll("*").forEach((element) => {
    if (element.shadowRoot) {
      bindFormsCopyButtonState(element.shadowRoot);
      observeFormsCopyRoot(element.shadowRoot);
    }
  });
}

function initFormsCustomizations() {
  bindFormsCopyButtons();

  const formsCopyButtonObserver = new MutationObserver(bindFormsCopyButtons);
  formsCopyButtonObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFormsCustomizations);
} else {
  initFormsCustomizations();
}
